import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  COLLECTIONS_CREATE_GOOGLE_CALENDAR_MAPPING_IN_COLLECTION_BEGIN,
  COLLECTIONS_CREATE_GOOGLE_CALENDAR_MAPPING_IN_COLLECTION_SUCCESS,
  COLLECTIONS_CREATE_GOOGLE_CALENDAR_MAPPING_IN_COLLECTION_FAILURE,
  COLLECTIONS_CREATE_GOOGLE_CALENDAR_MAPPING_IN_COLLECTION_DISMISS_ERROR,
} from './constants';
import { getErrorMessageFromResponse } from '../../../common/utils/errorUtils';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { toast } from 'react-toastify';

export function createGoogleCalendarMappingInCollection(args = {}) {
  return (dispatch) => {
    dispatch({
      type: COLLECTIONS_CREATE_GOOGLE_CALENDAR_MAPPING_IN_COLLECTION_BEGIN,
    });

    const { projectId, version, data, selectedCollection } = args;
    const { uuid: collectionUuid, googleCalendarMapping = [] } = selectedCollection;
    const header = builderSurfaceJsonContentHeader(projectId);
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.post(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/google-calendar-mapping/${collectionUuid}/collection`,
        data,
        header,
      );
      doRequest.then(
        (res) => {
          toast.success(
            googleCalendarMapping && googleCalendarMapping.length
              ? 'Google Calendar Mapping Updated Successfully !'
              : 'Google Calendar Mapping Created Successfully !',
          );
          dispatch({
            type: COLLECTIONS_CREATE_GOOGLE_CALENDAR_MAPPING_IN_COLLECTION_SUCCESS,
            data: res,
          });
          Mixpanel.track(
            googleCalendarMapping && googleCalendarMapping.length
              ? 'Updated collection google calendar mapping'
              : 'Created collection google calendar mapping',
          );
          resolve(res);
        },
        (err) => {
          dispatch({
            type: COLLECTIONS_CREATE_GOOGLE_CALENDAR_MAPPING_IN_COLLECTION_FAILURE,
            data: { error: err },
          });
          Mixpanel.track(
            googleCalendarMapping && googleCalendarMapping.length
              ? 'Failed to update collection google calendar mapping'
              : 'Failed to create collection google calendar mapping',
          );
          const errMsg = getErrorMessageFromResponse(err);
          toast.error(`Failed: ${errMsg}`, {});
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissCreateGoogleCalendarMappingInCollectionError() {
  return {
    type: COLLECTIONS_CREATE_GOOGLE_CALENDAR_MAPPING_IN_COLLECTION_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case COLLECTIONS_CREATE_GOOGLE_CALENDAR_MAPPING_IN_COLLECTION_BEGIN:
      return {
        ...state,
        createGoogleCalendarMappingInCollectionPending: true,
        createGoogleCalendarMappingInCollectionError: null,
      };

    case COLLECTIONS_CREATE_GOOGLE_CALENDAR_MAPPING_IN_COLLECTION_SUCCESS:
      return {
        ...state,
        createGoogleCalendarMappingInCollectionPending: false,
        createGoogleCalendarMappingInCollectionError: null,
      };

    case COLLECTIONS_CREATE_GOOGLE_CALENDAR_MAPPING_IN_COLLECTION_FAILURE:
      return {
        ...state,
        createGoogleCalendarMappingInCollectionPending: false,
        createGoogleCalendarMappingInCollectionError: action.data.error,
      };

    case COLLECTIONS_CREATE_GOOGLE_CALENDAR_MAPPING_IN_COLLECTION_DISMISS_ERROR:
      return {
        ...state,
        createGoogleCalendarMappingInCollectionError: null,
      };

    default:
      return state;
  }
}
